import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { ProductionListPageFilterSchema } from './-zod-schema';

// プロダクション 一覧 (PN Force グローバルメニュー)。
// URL search のスキーマだけここで定義し、コンポーネントは index.lazy.tsx
// 側で createLazyFileRoute 経由で遅延ロードして bundle 分割する。
// (products / test-sets / values と同じパターン: DataTable / useReactTable の
//  重い generic 推論を module 境界で trunk typecheck から分離 → cascade 回避)
export const Route = createFileRoute('/_stacktrace/production/')({
  validateSearch: zodValidator(ProductionListPageFilterSchema),
});
